const state = {
  login: '/auth/cms/login',
  customer: '/customer',
  sku: '/sku',
  submission: '/sku/submission',
  productSubmission: '/products-price/submission',
  vendor: '/supplier',
  customerResetPassword: 'customer/reset-password',
  uservendor: '/supplier/users',
  vendorRecommend: '/supplier/recommend',

  projectType: '/ecom/project/type',

  bid: '/cms/bid',

  bank: '/bank',

  province: '/region/province',
  city: '/region/city', // Kabupaten / Kota
  district: '/region/district', // Kecamatan
  regionOrigin: '/region/origin',
  postalCode: '/postal-code/list-postal-code',

  salesCode: '/mitra',
  setPassword: 'user/cms/set-password',
  setNewPassword: 'user/cms/set-new-password',
  allCategory: '/sku/categories',
  categoryList: '/item-category/all-category/list',
  category1: '/item-category',
  category1CofirmDelete: '/item-category/confirm',
  category2: '/category',
  category2CofirmDelete: '/category/confirm',
  category3: '/sub-category',
  category3CofirmDelete: '/sub-category/confirm',
  brand: '/brand',
  subCategory: '/sub-category',
  product: '/product',
  productSupplier: '/product/supplier',
  productSupplierDetail: '/product/supplier/detail',
  productSupplierHistory: '/product/supplier/history',
  productFluctuation: '/fluctuation/product',
  variant: '/variant',
  unit: '/unit',
  discount: '/discount',
  marginPercentage: '/sub-category/adjust-profit',
  referal: '/referal',

  skuImage: '/sku/image',

  so: '/so',
  soItems: '/so/items',
  po: '/po',
  poCalculate: '/po/calculate',
  do: '/do',
  doReturnLetter: '/do/return-letter',
  doDriver: '/do/driver',
  doDeliveryFee: '/do/delivery-fee',
  vendorPayment: '/vendor-paid',
  cmsInvoice: '/cms/invoice',
  cmsInvoiceExport: '/cms/invoice/export',
  cmsInvoiceDisbursementExport: '/cms/invoice/disbursement/export-excel',
  cmsInvoiceDetail: '/cms/invoice/detail',
  cmsInvoiceDocs: '/cms/invoice/documents',
  invoice: '/invoice',
  invoiceList: '/invoice-list',
  invoiceDetail: '/invoice-detail',
  invoiceSo: '/invoice-so',
  taxInvoice: '/tax-invoice',
  confirmPayment: '/confirmSoPayment',
  monitoringFlow: '/monitoring-flow',
  monitoringFlowChat: 'monitoring-flow/chat',

  dashboard: '/dashboard',
  dashboardport: '/dashboard/portofolio',
  dashboardproduct: '/dashboard/top-product',
  dashboardvendor: '/dashboard/top-vendor',
  dashboardcustomer: '/dashboard/top-customer',

  productPromo: '/promotion/list-product',

  accessType: '/role',
  roleDetail: '/role/detail',
  roleModule: '/module',

  admin: '/user/cms',
  adminDeleted: '/user/cms/update/user-deleted',
  adminPost: '/auth/cms/register',
  adminForgotPassword: '/user/cms/send-token',

  partner: '/mitra',
  perform: '/mitra/perform',
  pic: '/company/pic',
  documentGradeC: '/company/document/grade',
  companyVerification: '/company/verif',

  coa: '/coa',

  costIncome: '/other-income',

  fileUpload: '/file-upload',

  profitLoss: '/profit',
  profile: '/user/cms',

  changePass: '/auth/cms/change-password',
  resetPass: '/auth/cms/forget-password',

  bnpl: '/cms/bnpl',
  partnerBnpl: '/cms/company',
  changeMainBnpl: '/cms/bnpl-company',

  profitTargetSku: '/target-profit/sku',
  profitTargetSkuSummary: '/target-profit/summary-sku',
  profitTargetCategory: '/target-profit/sub-category',
  profitTargetApproval: '/target-profit/approval',
  profitTargetBrand: '/target-profit/brand',

  countryCode: '/country-code',

  genAi: '/cms/generate-ai'
}

export default {
  state
}
